export const SET_QUESTIONS = "set_questions_rich_text";
export const UPDATE_QUESTIONS = "update_questions";